import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadioButtonChecked = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M218 500C217 320 329 218 498 218C667 218 783 320 782 500C781 693 667 782 498 782C329 782 219 693 218 500ZM0 498C-1 817 203 999 498 1000C793 1001 999 817 1000 498C1001 207 793 1 498 0C203 -1 1 207 0 498ZM80 500C80 255 255 82 498 82C741 82 920 255 920 500C920 764 741 918 498 918C255 918 80 764 80 500Z" })
});
export default SvgRadioButtonChecked;
